import React, { PureComponent } from 'react'
import Link, { withPrefix } from 'gatsby-link'
// import { formatDate } from '../../util'
import './WordCloudPreview.css'

class WordCloudPreview extends PureComponent {
  state = {
    fakeHeight: true,
  }
  render() {
    const { wordCloud, onClick } = this.props
    const { fakeHeight } = this.state
    return (
      <div className={`WordCloudPreview ${fakeHeight ? 'fakeHeight' : ''}`} onClick={e => onClick(wordCloud, e)}>
        {/* <Link to={`/clouds/${wordCloud.name}`}> */}
        <img src={withPrefix(wordCloud.image)} onLoad={() => this.setState({ fakeHeight: false })}/>
        {/* </Link> */}
        <div className="WordCloudPreview-bottom-text">
          {/* <div>{formatDate(wordCloud.date)}</div> */}
          <div>{wordCloud.date}</div>
        </div>
      </div>
    )
  }
}

export default WordCloudPreview



// WEBPACK FOOTER //
// ./src/components/WorldCloudPreview/WordCloudPreview.js